import React from "react";
import * as S from "./styles";

export const FeaturesNew: React.FC = () => {
  return (
    <>
      <S.Container>
        <S.GroupCards>
          <S.Card>
            <div className="orange_ball">
              <div className="black_ball">
                <S.IconEnginer alt="icone" />
              </div>
            </div>
            <h3>Gestão Pessoal:</h3>
            <p>Treinamento para os Franqueados</p>
            <p>Treinamento para os Colaboradores</p>
          </S.Card>
          <S.Card>
            <div className="orange_ball">
              <div className="black_ball">
                <S.IconMarket alt="icone" />
              </div>
            </div>
            <h3>Ponto de instalação de unidade:</h3>
            <p>Escolha o ponto comercial</p>
            <p>Projeto de arquitetura</p>
            <p>Reforma e montagem</p>
          </S.Card>
          <S.Card>
            <div className="orange_ball">
              <div className="black_ball">
                <S.IconPaint alt="icone" />
              </div>
            </div>
            <h3>Reforma e montagem:</h3>
            <p>Fornecedores Homologados</p>
            <p>Compras centralizadas em nossa ferramenta oplog</p>
          </S.Card>
          <S.Card>
            <div className="orange_ball">
              <div className="black_ball">
                <S.IconTech alt="icone" />
              </div>
            </div>
            <h3>Software e tecnologia:</h3>
            <p>Smart - Software de administração de atividades.</p>
            <p>
              Tecnologia - Desenvolvemos toda a nossa plataforma em nuvem,
              possibilitando o acompanhamento dos resultados em tempo real.
            </p>
            <p>
              Suporte - Ferramenta OP Helpdesk, nosso canal de suporte técnico.
            </p>
          </S.Card>
          <S.Card>
            <div className="orange_ball">
              <div className="black_ball">
                <S.IconBook alt="icone" />
              </div>
            </div>
            <h3>Manuais:</h3>
            <p>
              Operacional - Descrito de maneira clara e didática, oferecendo aos
              colaboradores e gerentes facilidade para manter o padrão de cada
              atividade operacional do consultório.
            </p>
            <p>
              Implantação - Manual de Implantação da Unidade, juntamente com o
              trabalho do consultor de campo, oferece ao franqueado todas as
              informações necessárias para a condução do processo de montagem da
              clínica.
            </p>
            <p>
              Padrão - Manual de Padrão Físico da Clínica com detalhes de
              construção, equipamentos e identidade visual.
            </p>
          </S.Card>
        </S.GroupCards>
      </S.Container>
    </>
  );
};
